import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./searchGateModal.css";

const FREE_SEARCH_LIMIT = 500;
const STORAGE_KEY = "dmi_free_search_count";

export function getFreeSearchCount() {
  try {
    return parseInt(localStorage.getItem(STORAGE_KEY) || "0", 10);
  } catch {
    return 0;
  }
}

export function incrementFreeSearchCount() {
  try {
    const next = getFreeSearchCount() + 1;
    localStorage.setItem(STORAGE_KEY, String(next));
    return next;
  } catch {
    return 0;
  }
}

export function hasReachedFreeLimit() {
  return getFreeSearchCount() >= FREE_SEARCH_LIMIT;
}

export function clearFreeSearchCount() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export default function SearchGateModal({ onDismiss }) {
  const { loginWithRedirect } = useAuth0();

  const remaining = Math.max(0, FREE_SEARCH_LIMIT - getFreeSearchCount());

  return (
    <div className="gate-overlay" onClick={onDismiss}>
      <div className="gate-modal" onClick={(e) => e.stopPropagation()}>
        <div className="gate-icon">
          <i className="fa-solid fa-lock" />
        </div>

        <h2 className="gate-title">You've used your free searches</h2>
        <p className="gate-subtitle">
          Create a free account to get unlimited access to evidence-based
          clinical answers.
        </p>

        <div className="gate-actions">
          <button
            className="gate-btn gate-btn-primary"
            onClick={() =>
              loginWithRedirect({
                authorizationParams: { screen_hint: "signup" },
                appState: { returnTo: "/" },
              })
            }
          >
            Create free account
          </button>
          <button
            className="gate-btn gate-btn-secondary"
            onClick={() =>
              loginWithRedirect({ appState: { returnTo: "/" } })
            }
          >
            Log in
          </button>
        </div>

        <p className="gate-fine-print">
          No credit card required &middot; Free forever for basic use
        </p>
      </div>
    </div>
  );
}
